import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M16.15 3a.7.7 0 0 1 .495.205l4.15 4.15a.7.7 0 0 1 0 .99L9.728 19.412a.7.7 0 0 1-.325.184L3.87 20.979a.7.7 0 0 1-.85-.849l1.384-5.533a.7.7 0 0 1 .184-.325L15.655 3.205A.7.7 0 0 1 16.15 3ZM5.463 16.136l-.8 3.202 3.201-.8-2.401-2.402Zm3.77 1.79-3.16-3.16L16.15 4.69l3.16 3.16L9.233 17.927Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
